export const PROJECTNAMEFA = "لیدوما تریپ";
export const BASE_URL = "https://lidomatrip.com";
export const BASE_URL2 = "https://lidomatrip.com";
//
export const BASE_URL_UPLOAD = "https://lidomatrip.com";
export const BASE_URL_SITE = "https://lidomatrip.com";

// Lidoma
export const BASE_URL_IMAGE = "https://lidomatrip.com";
export const PROJECTNAME = "LidomaTrip";
